import 'wa.ui.react-editor';
import './src/webpack-public-path';
// import 'semantic-ui-less/definitions/elements/icon.less';
import './src/components/event-registration-wizard';
import './src/components/add-event-to-calendar-dropdown';
import './src/components/two-factor-auth-challenge';
